<template>
  <!-- PRODUCT PAGE -->
  <section class="section-product-page">
    <div class="container">

      <div class="content" style="margin-bottom: 10px">
        <div class="text-center">
          <div class="capital-label-wrapper">
            <!-- CAPITAL LABEL -->
            <span class="capital-label">EXPLORE OUR PLASTICS RESINS FROM VARIOUS BRANDS</span>
            <!-- CAPITAL LABEL -->
          </div>

          <!-- SECTION TITLE -->
          <h1 class="section-title h2 text-black h2-caslon f-44" > Products</h1>
          <!-- SECTION TITLE -->
        </div>
      </div>

      <div class="row m-0">

        <div class="col-12 col-md-6 p-0 mb-2">
          <div class="content">
            <!-- PRODUCT CARD -->
            <div class="product-card">
              <div class="product-card-image">
                <a href="/th/plastics/products/high-performance-plastics">
                  <img src="/pages/products/n-products.jpg" alt="High Performance Plastics">
                </a>
              </div>
              <div class="product-card-content">
                <a href="/th/plastics/products/sustainable-plastics">
                  <span class="product-card-title">High Performance Plastics</span>
                </a>
                <ul>
                  <li>Very high service temperature</li>
                  <li>High strength at elevated temperature</li>
                  <li>Excellent chemical resistance</li>
                  <li>Special effects</li>
                  <li>Designed for specifically use</li>
                </ul>
              </div>
            </div>
            <!-- PRODUCT CARD -->
          </div>
        </div>

        <div class="col-12 col-md-6 p-0 mb-2">
          <div class="content">
            <!-- PRODUCT CARD -->
            <div class="product-card">
              <div class="product-card-image">
                <a href="/th/plastics/products/sustainable-plastics">
                  <img src="/pages/products/sus1.jpg" alt="Sustainable Plastics">
                </a>
              </div>
              <div class="product-card-content">
                <a href="/th/plastics/products/sustainable-plastics">
                  <span class="product-card-title">Sustainable Plastics</span>
                </a>
                <ul>
                  <li>Plastics from renewable sources</li>
                  <li>Lower carbon footprint</li>
                  <li>Promote circular economy</li>
                  <li>Quality like virgin grade</li>
                </ul>
              </div>
            </div>
            <!-- PRODUCT CARD -->
          </div>
        </div>

        <div class="col-12 col-md-6 p-0">
          <div class="content">
            <!-- PRODUCT CARD -->
            <div class="product-card">
              <div class="product-card-image">
                <a href="/th/plastics/products/engineering-plastics">
                  <img src="/pages/products/eng.jpg" alt="Engineering Plastics">
                </a>
              </div>
              <div class="product-card-content">
                <a href="/th/plastics/products/engineering-plastics">
                  <span class="product-card-title">Engineering Plastics</span>
                </a>
                <ul>
                  <li>Widely used in structural parts</li>
                  <li>Good impact, strength, stiffness</li>
                  <li>Good chemical resistance</li>
                  <li>Good heat resistance</li>
                </ul>
              </div>
            </div>
            <!-- PRODUCT CARD -->
          </div>
        </div>

        <div class="col-12 col-md-6 p-0">
          <div class="content">
            <!-- PRODUCT CARD -->
            <div class="product-card">
              <div class="product-card-image">
                <a href="/th/plastics/products/commodity-plastics">
                  <img src="/pages/products/comm.jpg" alt="Commodity Plastics">
                </a>
              </div>
              <div class="product-card-content">
                <a href="/th/plastics/products/commodity-plastics">
                  <span class="product-card-title">Commodity Plastics</span>
                </a>
                <ul>
                  <li>General purpose</li>
                  <li>Low cost</li>
                </ul>
              </div>
            </div>
            <!-- PRODUCT CARD -->
          </div>
        </div>
      </div>
    </div>

  </section>
  <!-- PRODUCT PAGE -->
</template>
<script setup>
useHead({
  title:'Products - NAGASE THAILAND Engineering Plastics',
})

</script>
